'use strict';

angular.module('common')
.controller('unsubscribeCtrl', function ($scope, $stateParams, $mdDialog) {
    'ngInject';

    $scope.project = $stateParams.project;
    console.log($scope.project);

    $scope.unsubscribe = function(email)
    {
        if ($scope.project && email)
        {
            var ref = firebase.database().ref('projectData/' + $scope.project + '/publicWriteOnly/mailingListOptOut/');
            ref.push({"email":email}).then(function() {
              alert = $mdDialog.alert({
                title: 'Unsubscribe',
                textContent: 'You have been unsubscrbed from the mailing list.',
                ok: 'OK'
              });

              $mdDialog
                .show( alert )
                .finally(function() {
                  alert = undefined;
                });
            });
        }
    };

});
